/* eslint-disable jsx-a11y/no-redundant-roles */
import React from "react";

// imported form
import Contactform from "./Subassets/Contactform";
const Form = () => {
  return (
    <>
      <section aria-label="contact form" className="py-5 formbg">
        <span className="max-w-5xl mx-auto sm:py-24 sm:px-6 lg:px-8">
          <span className="relative rounded-md shadow-xl bg-slate-800/90">
            <h1 className="sr-only">Contact Me</h1>

            <section aria-label="form lets connect" className="">
              {/* Contact form */}
              <Contactform />
            </section>
          </span>
        </span>
      </section>
    </>
  );
};
export default Form;
